var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"boardal"}},[_c('div',{staticClass:"boardal"},[(_vm.hasMask)?_c('div',{staticClass:"boardal__mask",on:{"click":_vm.clickMask}}):_vm._e(),_c('div',{staticClass:"boardal__wrapper"},[_vm._t("default"),(_vm.hasX)?_c('div',{staticClass:"boardal__x",on:{"click":_vm.clickX}},[_vm._v("×")]):_vm._e()],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }